import { useTranslation, Trans } from 'react-i18next'
import styled from 'styled-components'
import { length } from 'ramda'
import { colors } from '@/styles'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 16px 0;
`

const Paragraph = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: ${colors.grey48};
  text-align: left;
  margin: 0;
`

const ModalContent = ({ first_name, last_name, sentDocuments, isAdd }) => {
  const { t } = useTranslation()
  const isPlural = length(sentDocuments) > 1
  const userName = `${first_name} ${last_name}`

  return (
    <Wrapper>
      {isPlural ? (
        <Paragraph>
          {isAdd ? (
            <Trans i18nKey="l.void_modal_content.add_user.text" t={t} userName={userName}>
              By adding {{ userName }} as a signing recipient, any sent document will be voided.
            </Trans>
          ) : (
            <Trans i18nKey="l.void_modal_content.plural.text" t={t} userName={userName}>
              By changing {{ userName }}'s signing status to signature required, any sent document
              will be voided.
            </Trans>
          )}
        </Paragraph>
      ) : (
        <Paragraph>
          {isAdd ? (
            <Trans i18nKey="l.void_modal_content.add_user.text" t={t} userName={userName}>
              By adding {{ userName }} as a signing recipient, any sent document will be voided.
            </Trans>
          ) : (
            <Trans i18nKey="l.void_modal_content.singular.text" t={t} userName={userName}>
              By changing {{ userName }}'s signing status to signature required, this document will
              be voided.
            </Trans>
          )}
        </Paragraph>
      )}
      <Paragraph>
        {t(
          'l.void_modal_content.paragraph.text',
          `This will cancel all remaining signing activities and you will need to resend the updated document back to the recipient(s) to be signed.`
        )}
      </Paragraph>
    </Wrapper>
  )
}

export default ModalContent
